var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative z-0"},[_c('div',{staticClass:"text-2xl font-bold text-center text-secondary mb-8"},[_vm._v(_vm._s(_vm.data.Name))]),_vm._v(" "),(_vm.data)?_c('div',{ref:"map",staticClass:"w-full h-[400px]"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }